import { render, staticRenderFns } from "./LaporanDesentif.vue?vue&type=template&id=2dacd114"
import script from "./LaporanDesentif.vue?vue&type=script&lang=js"
export * from "./LaporanDesentif.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports